/**
 * Bundle Builder API client — thin wrappers over /api/documents/bundle.
 *
 * The X-Bonsai-User-Id session header is injected globally by the axios
 * interceptor in config/api.js, so these helpers only carry payloads. Every
 * route 404s server-side when BUNDLE_BUILDER_ENABLED is off — callers should
 * gate the UI on the build-time flag so those calls are never made.
 */
import axios from "axios";
import { API } from "../config/api";

const BASE = `${API}/documents/bundle`;

export async function getBasket() {
  const { data } = await axios.get(BASE);
  return data;
}

export async function addToBasket(item) {
  const { data } = await axios.post(`${BASE}/items`, item);
  return data;
}

export async function relabelItem(itemId, label) {
  const { data } = await axios.patch(`${BASE}/items/${itemId}`, { label });
  return data;
}

export async function removeItem(itemId) {
  const { data } = await axios.delete(`${BASE}/items/${itemId}`);
  return data;
}

export async function reorderBasket(order) {
  const { data } = await axios.post(`${BASE}/reorder`, { order });
  return data;
}

export async function moveItem(itemId, direction) {
  const { data } = await axios.post(`${BASE}/move`, { item_id: itemId, direction });
  return data;
}

export async function clearBasket() {
  const { data } = await axios.delete(BASE);
  return data;
}

export async function saveDraft({ name, matter_ref }) {
  const { data } = await axios.post(`${BASE}/drafts`, { name, matter_ref });
  return data;
}

export async function listDrafts(matterRef) {
  const { data } = await axios.get(`${BASE}/drafts`, {
    params: matterRef ? { matter_ref: matterRef } : {},
  });
  return data;
}

export async function openDraft(draftId) {
  const { data } = await axios.post(`${BASE}/drafts/${draftId}/open`);
  return data;
}

export async function deleteDraft(draftId) {
  const { data } = await axios.delete(`${BASE}/drafts/${draftId}`);
  return data;
}

/** POST a streaming endpoint and trigger a browser file download. */
async function downloadStream(path, filename, body) {
  const res = await axios.post(`${BASE}${path}`, body || {}, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function downloadZip(body) {
  return downloadStream("/zip", "bundle.zip", body);
}

export function downloadBundlePdf(body) {
  return downloadStream("/export", "bundle.pdf", body);
}

export async function uploadToMatter(matterRef, files) {
  const form = new FormData();
  form.append("matter_ref", matterRef);
  Array.from(files).forEach((f) => form.append("files", f));
  const { data } = await axios.post(`${BASE}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
